/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  Box,
  Button,
  Center,
  CircularProgress,
  Divider,
  Flex,
  Image,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import TrainingModuleHeader from 'Components/Headers/TrainingModuleHeader'
import Layout from 'Components/Layout'
import ReactPlayer from 'react-player'
import succeed from '../../Assets/Common/Succeed.svg'

import React, {
  useEffect,
  useRef,
  //  useEffect,
  useState,
} from 'react'
import { ChevronLeftIcon, ChevronRightIcon, DownloadIcon } from '@chakra-ui/icons'
import Chapters from './Chapters'
import {
  useLazyGetTrainingDataQuery,
  useSendWatchTimeLogsMutation,
  useSetVideoWatchLogsMutation,
} from 'Services/API/posp.api'

import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ToastService } from 'Services/toast.service'
import { Modal } from 'Core'
import { PospImages } from 'Assets/Posp'
import { useDeviceType } from 'app/hooks'
import moment from 'moment'

const TrainingModule = () => {
  const { journeyType } = useSelector((state: any) => state.user)
  const [type, setType] = useState(journeyType.toLowerCase())
  const navigate = useNavigate()
  const { isMobile } = useDeviceType()
  const [getMediaData, { isLoading: getMediaLoading }] = useLazyGetTrainingDataQuery()

  const [setVideoWatchLogs] = useSetVideoWatchLogsMutation()
  const [sendWatchTimeLogs] = useSendWatchTimeLogsMutation()
  const [isCompleted, setIsCompleted] = useState({})
  const [activeIndex, setActiveIndex] = useState(0)
  const [currentVideo, setCurrentVideo] = useState<any>()
  const [pdf, setPdf] = useState('')
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false)

  const [totalWatchTime, setTotalWatchTime] = useState(0)
  const [time, setTime] = useState(0)
  const [playing, setPlaying] = useState(true)
  const [timeToBeShown, setTimeToBeShown] = useState<any>('')
  const [TimewatchLimit, setTimewatchLimit] = useState(60)
  const [trainingStartTimestamp, setTrainingStartTimestamp] = useState<any>(Date.now())
  const currentTime = Date.now()
  // console.log('trainingStartTimestamp', trainingStartTimestamp)
  // const TimewatchLimit = 172800000 // 48 hrs

  // console.log('timeRemaining: ', moment(trainingStartTimestamp).fromNow())
  // console.log('currentDate', Date.now())

  const beforeWeStart = [
    {
      created_at: '2023-04-03T11:55:25.676490',
      data_type: 'video',
      data_url: '',
      duration: 0,
      id: 0,
      insurance_type: 'LIFE',
      is_watched: 0,
      progress: 0,
      title: 'Before we start',
      updated_at: '',
      video_id: 0,
      video_status: 1,
    },
  ]
  const [videos, setVideos] = useState<any>([])
  const videoRef: any = useRef(null)

  const handlePrevClick = () => {
    if (activeIndex > 0) {
      setActiveIndex((activeIndex) => activeIndex - 1)
    } else {
      navigate('/registration-status')
    }
  }
  const handleNextClick = () => {
    if (activeIndex < videos.length - 1 && videos[activeIndex].is_watched === 1) {
      setActiveIndex((activeIndex) => activeIndex + 1)
    }
    if (activeIndex === videos.length - 1 && videos[videos.length - 1].is_watched === 1) {
      setIsSuccessModalOpen(true)
    }
  }

  const handleDownloadPdf = () => {
    const anchor = document.createElement('a')
    anchor.href = pdf
    anchor.target = '_blank'
    anchor.download = `Report-${new Date()}.csv`
    anchor.click()
    const dummy: any = [...videos]
    dummy[0] = { ...dummy[0], video_status: 2, is_watched: 1 }
    setVideos(dummy)
  }
  const GetMediaHandler = async () => {
    console.log('calling getMediaHandler')
    try {
      const getMediaDataResponse: any = await getMediaData(journeyType).unwrap()
      if (getMediaDataResponse?.status === 200) {
        // setTrainingStartTimestamp(getMediaDataResponse?.data.training_start_timestamp)
        if (getMediaDataResponse?.data.training_start_timestamp) {
          const dateTransformed = moment(getMediaDataResponse?.data.training_start_timestamp)
          const millisecondsSinceEpoch = dateTransformed.valueOf()
          setTrainingStartTimestamp(millisecondsSinceEpoch)
        } else {
          setTrainingStartTimestamp(false)
        }
        if (getMediaDataResponse?.data?.training_watch_time) {
          setTimewatchLimit((getMediaDataResponse?.data?.training_watch_time || 0) * 60 * 60 * 1000)
        }
        const dummyVid1: any = beforeWeStart
        if (getMediaDataResponse?.data?.training_videos[0]?.progress) {
          dummyVid1[0].is_watched = 1
          dummyVid1[0].video_status = 2
        }
        const dummyVid2: any = getMediaDataResponse?.data?.training_videos
        const completeListing = dummyVid1.concat(dummyVid2)
        const activeVideoIndex = completeListing.findIndex((val: any) => val.is_watched === 0)
        if (activeVideoIndex === -1) {
          setActiveIndex(completeListing.length - 1)
        } else {
          setActiveIndex(activeVideoIndex)
        }

        setVideos(completeListing)
      }
      setPdf(getMediaDataResponse?.data?.[`${journeyType.toLowerCase()}_pdf`])
    } catch (err) {
      console.log('error', err)
    }
  }

  const handleVideoWatchLogs = async (time: any, lastCall?: boolean) => {
    const logsResponse: any = await setVideoWatchLogs({
      current_duration: Math.floor(time),
      video_id: currentVideo?.video_id,
    })
    if (logsResponse?.data?.status === 200) {
      if (lastCall) {
        GetMediaHandler()
      }
      if (logsResponse?.data?.data?.training_start_time) {
        const dateTransformed = moment(logsResponse?.data?.data?.training_start_time)
        const millisecondsSinceEpoch = dateTransformed.valueOf()
        setTrainingStartTimestamp(millisecondsSinceEpoch)
      }
    } else if (logsResponse?.error?.data?.status === 400) {
      if (logsResponse?.error?.data?.message) {
        ToastService.showInfoToast({
          title: 'Info',
          message: logsResponse?.error?.data?.message,
        })
        videoRef.current.seekTo(logsResponse?.error?.data?.data?.current_duration)
      }
    }
  }

  const handleSendWatchTimeLogs = async () => {
    try {
      const sendWatchTimeResp = await sendWatchTimeLogs({ training_current_sec: totalWatchTime })
      console.log('sendWatchTimeResp', sendWatchTimeResp)
    } catch (err) {
      ToastService.showErrorToast({ title: 'Error', message: 'Something Went Wrong' })
    }
  }

  const handleDisableCheckbox = (val: any, index: number) => {
    if (index === 1 && videos[index - 1]?.video_status === 1) {
      return 0
    }
    return val.video_status
  }

  useEffect(() => {
    GetMediaHandler()
  }, [])

  useEffect(() => {
    if (activeIndex === 0) {
      setCurrentVideo({})
    } else {
      setCurrentVideo(videos[activeIndex])
    }
  }, [activeIndex])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    if (videos) {
      let prevTime = 0
      let total = 0
      for (let i = 1; i < videos?.length; i++) {
        if (videos[i]?.video_status === 2) {
          prevTime = prevTime + videos[i].duration
        }
        if (videos[i]?.video_status === 1) {
          const seekSeconds = Math.floor((videos[i].progress * videos[i].duration) / 100)
          prevTime = prevTime + seekSeconds
        }

        total += videos[i]?.duration
      }

      setTotalWatchTime(prevTime)
      // setTotalVideoDuration(total)
    }
  }, [videos])

  // const getTimes = () => {
  //   let totalTime = 0
  //   for (let i = 1; i < videos?.length; i++) {
  //     if (videos[i]?.video_status === 2 || videos[i]?.video_status === 1) {
  //       totalTime = totalTime + videos[i].duration
  //     }
  //   }
  //   if (totalWatchTime <= totalTime) {
  //     return true
  //   } else {
  //     return false
  //   }
  // }

  // useEffect(() => {
  //   if (videos.length && playing && currentVideo?.video_status === 1 && getTimes()) {
  //     const timer = setTimeout(() => {
  //       setTotalWatchTime(totalWatchTime + 1)
  //     }, 1000)
  //     return () => {
  //       clearTimeout(timer)
  //     }
  //   }
  // }, [totalWatchTime, playing, currentVideo])
  console.log(TimewatchLimit)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (trainingStartTimestamp && TimewatchLimit) {
        const remainingTime = trainingStartTimestamp + TimewatchLimit - currentTime
        if (remainingTime > 0) {
          setTimeToBeShown(remainingTime)
        } else {
          setTimeToBeShown('over')
        }
      }
      setPlaying(videoRef?.current?.player?.isPlaying)
      setTime(time + 1)
    }, 500)
    return () => {
      clearTimeout(timer)
    }
  }, [time])

  useEffect(() => {
    if (timeToBeShown === 'over') {
      navigate('/registration-status')
    }
  }, [timeToBeShown, trainingStartTimestamp])

  return (
    <Layout
      HeaderComponent={
        <TrainingModuleHeader
          timeComponent={
            trainingStartTimestamp && timeToBeShown !== 'over' ? (
              <Box color={'#366B9E'} fontWeight={'bold'}>
                {moment.duration(timeToBeShown).days()
                  ? `${Math.floor(moment.duration(timeToBeShown).days())} day: `
                  : ''}
                {moment.duration(timeToBeShown).hours()
                  ? `${Math.floor(moment.duration(timeToBeShown).hours())} hrs: `
                  : ''}
                {moment.duration(timeToBeShown).minutes()
                  ? `${Math.floor(moment.duration(timeToBeShown).minutes())} min: `
                  : ''}
                {moment.duration(timeToBeShown).seconds()
                  ? `${Math.floor(moment.duration(timeToBeShown).seconds())} sec  `
                  : ''}
                left
              </Box>
            ) : trainingStartTimestamp && timeToBeShown === 'over' ? (
              <Text color={'#366B9E'} fontWeight={'bold'}>
                Loading...
              </Text>
            ) : (
              <Box color={'#366B9E'} fontWeight={'bold'}>
                {TimewatchLimit && TimewatchLimit != 60 && (
                  <>
                    {moment.duration(TimewatchLimit).days()
                      ? `${Math.floor(moment.duration(TimewatchLimit).days())} day: `
                      : ''}
                    {moment.duration(TimewatchLimit).hours()
                      ? `${Math.floor(moment.duration(TimewatchLimit).hours())} hrs `
                      : ''}
                    {moment.duration(TimewatchLimit).minutes()
                      ? `${Math.floor(moment.duration(TimewatchLimit).minutes())} min `
                      : ''}
                    {moment.duration(TimewatchLimit).seconds()
                      ? `${Math.floor(moment.duration(TimewatchLimit).seconds())} sec  `
                      : ''}
                    left
                  </>
                )}
              </Box>
            )
          }
          userStateData={{}}
          type={type}
          setType={setType}
        />
      }
    >
      <Box position='relative' zIndex={1}>
        <Modal isOpen={isSuccessModalOpen} onClose={() => console.log('')}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <Center>
                <Image src={PospImages.SucceedIcon} width='80px' />
              </Center>
            </ModalHeader>
            <ModalBody pt={4} pb={10}>
              <Box>
                You have successfully completed your training. You may give your{' '}
                {journeyType === 'LIFE' ? 'Life' : 'General'} Exam now to complete your POSP journey
              </Box>

              <Flex gap={4} mt={3} justifyContent={'center'}>
                <Button variant={'outline'} onClick={() => navigate('/registration-status')}>
                  Back
                </Button>
                <Button onClick={() => navigate('/sp-registration/examination-instruction')}>
                  Next
                </Button>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
        {getMediaLoading ? (
          <Box
            height='100%'
            width='100%'
            zIndex={10}
            position='absolute'
            left='0%'
            top='0%'
            background='rgba(128,128,128,0.3)'
          >
            <Flex width={'100%'} height='100%' justifyContent={'center'} alignItems='center'>
              <CircularProgress isIndeterminate color='green.300' />
            </Flex>
          </Box>
        ) : null}
        {(type === 'life' || type === 'general') ? (
          <Box maxW='100%' pt={0.5}>
            <Flex direction={isMobile ? 'column' : 'row'} w='100%'>
              <Box w={isMobile ? 'full' : '70%'}>
                {activeIndex === 0 ? (
                  <Flex
                    borderBottom={'1px solid #EBEBEB'}
                    height={'50.5vh'}
                    padding={10}
                    flexDirection='column'
                    alignItems={'center'}
                    justifyContent='space-between'
                  >
                    <Flex flexDirection='column' alignItems={'center'}>
                      <Text fontSize='sm' fontWeight='semibold' mb={3}>
                        Before starting the course, please download the pdf from below.
                      </Text>
                      <Button
                        bgColor={'#1C6DA2'}
                        px={10}
                        py={5}
                        rounded='3xl'
                        isDisabled={!pdf}
                        fontWeight='normal'
                        onClick={() => {
                          handleDownloadPdf()
                          setIsCompleted({ ...isCompleted, 0: true })
                        }}
                        leftIcon={<DownloadIcon />}
                      >
                        Download PDF
                      </Button>
                    </Flex>

                    <Box mb={10} background={'#FFF3CD 0% 0% no-repeat padding-box'} color='#856404'>
                      <Center>
                        <Text px={7} py={3}>
                          Note: You can appear in exam in 15 hours, once the training module has
                          started.
                        </Text>
                      </Center>
                    </Box>
                  </Flex>
                ) : (
                  <ReactPlayer
                    controls={true}
                    height={isMobile ? '200px' : '50vh'}
                    ref={videoRef}
                    width='100%'
                    progressInterval={10000}
                    muted={true}
                    // onPlay={() =>{
                    //   GetMediaHandler()
                    // }}
                    onReady={() => {
                      if (!currentVideo.is_watched) {
                        handleVideoWatchLogs(1)
                        videoRef.current.seekTo(
                          Math.floor((currentVideo.progress * currentVideo.duration) / 100),
                        )
                      }
                    }}
                    playing
                    onPause={() => {
                      if (!currentVideo.is_watched) {
                        handleVideoWatchLogs(Math.floor(videoRef.current.getCurrentTime()))
                      }
                    }}
                    onEnded={() => {
                      if (!currentVideo.is_watched) {
                        handleVideoWatchLogs(Math.floor(videoRef.current.getCurrentTime()), true)
                        // GetMediaHandler();
                      }

                      setIsCompleted({ ...isCompleted, [activeIndex]: true })
                    }}
                    onProgress={(e: any) => {
                      if (!currentVideo.is_watched) {
                        handleVideoWatchLogs(e.playedSeconds)
                        // handleSendWatchTimeLogs()
                      }
                    }}
                    url={`https://www.youtube.com/watch?v=${videos[activeIndex]?.data_url}`}
                  />
                )}

                {!isMobile && (
                  <Box mt={10}>
                    <Center>
                      <Button
                        fontSize={'sm'}
                        fontWeight='normal'
                        variant='outline'
                        mr={3}
                        px={10}
                        onClick={handlePrevClick}
                      >
                        BACK
                      </Button>

                      <Button
                        variant='solid'
                        fontSize={'sm'}
                        fontWeight='normal'
                        px={10}
                        onClick={() => {
                          handleNextClick()
                        }}
                        disabled={!videos?.[activeIndex]?.is_watched}
                      >
                        PROCEED TO NEXT STEP
                      </Button>

                      {/* <Button
                    bgColor={'#1C6DA2'}
                    variant="solid"
                    fontSize={'sm'}
                    fontWeight="normal"
                    px={10}
                    onClick={handleNextClick}
                  >
                    PROCEED TO NEXT STEP
                  </Button> */}
                    </Center>
                  </Box>
                )}
              </Box>
              <Box w={isMobile ? 'full' : '30%'} borderLeft={'1px solid #EBEBEB'}>
                <Text p={3} color={' #2C2C2C'} fontSize='md' fontWeight='bold'>
                  Course Content
                </Text>

                <Divider />

                <Box
                  height={'300px'}
                  py={3}
                  overflowY='scroll'
                  // borderLeft={'1px solid #EBEBEB'}
                >
                  <Flex overflowY={'scroll'} flexDirection={'column'} justifyContent='space-around'>
                    {videos?.map((val: any, ind: number) => (
                      <Box
                        px={3}
                        key={ind}
                        style={
                          activeIndex === ind
                            ? {
                                background: '#EBEBEB 0% 0% no-repeat padding-box',
                              }
                            : {}
                        }
                      >
                        <Chapters
                          activeIndex={activeIndex}
                          setActiveIndex={setActiveIndex}
                          index={ind}
                          name={val.title}
                          isCompleted={val.is_watched}
                          setIsCompleted={setIsCompleted}
                          disableVid={handleDisableCheckbox(val, ind)}
                        />
                      </Box>
                    ))}
                  </Flex>
                </Box>

                <Box p={4} borderTop={'1px solid #EBEBEB'} borderBottom={'1px solid #EBEBEB'}>
                  {isMobile ? (
                    <Center>
                      <Button
                        fontSize={'sm'}
                        fontWeight='normal'
                        variant='outline'
                        mr={3}
                        px={10}
                        onClick={handlePrevClick}
                      >
                        BACK
                      </Button>

                      <Button
                        variant='solid'
                        fontSize={'sm'}
                        fontWeight='normal'
                        px={10}
                        onClick={() => {
                          handleNextClick()
                        }}
                      >
                        NEXT
                      </Button>
                    </Center>
                  ) : (
                    <Center>
                      <Button
                        onClick={handlePrevClick}
                        leftIcon={<ChevronLeftIcon fontSize={25} />}
                        variant='outline'
                        mr={2}
                        size={'sm'}
                      />

                      <Button
                        onClick={handleNextClick}
                        size={'sm'}
                        leftIcon={<ChevronRightIcon fontSize={25} />}
                        variant='solid'
                      />
                    </Center>
                  )}
                </Box>
              </Box>
            </Flex>
          </Box>
        ) : (
          <Box>life insurance</Box>
        )}
      </Box>
    </Layout>
  )
}

export default TrainingModule
